import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useConfirmState, closeConfirm } from '@/hooks/useConfirm';

export function ConfirmDialog() {
  const { open, options } = useConfirmState();

  if (!options) return null;

  const variant = options.variant ?? 'destructive';

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) closeConfirm(false); }}>
      <DialogContent data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle>{options.title}</DialogTitle>
          <DialogDescription>{options.description}</DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-3 mt-4">
          <Button
            variant="outline"
            onClick={() => closeConfirm(false)}
            data-testid="confirm-dialog-cancel"
          >
            {options.cancelLabel ?? 'Cancel'}
          </Button>
          <Button
            variant={variant}
            onClick={() => closeConfirm(true)}
            data-testid="confirm-dialog-confirm"
          >
            {options.confirmLabel ?? 'Delete'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
